import aes256 from 'aes256';
const key = 'iid-crm-encryption-key';
const cipher = aes256.createCipher(key);

export const encrypted = (plaintext) => cipher.encrypt(JSON.stringify(plaintext));
export const decrypted = (encrypted) => JSON.parse(cipher.decrypt(encrypted));
